// Import libraries
import { err, ok, type Result } from "neverthrow";
import { z, ZodError } from "zod";
// Import Services
import type { IValidationService } from "./IValidationService";

export class ValidationService implements IValidationService {
  validate = <ItemType, SchemaType extends z.ZodTypeAny>(
    source: ItemType,
    schema: SchemaType
  ): Result<ItemType, ZodError> => {
    if (source == null || source == undefined) {
      const myError = new z.ZodError([
        {
          code: z.ZodIssueCode.custom,
          path: [""],
          message: "Input null or undefined",
        },
      ]);
      return err(myError);
    }
    const baseSchema = Array.isArray(source) ? z.array(schema) : schema;
    try {
      return ok(baseSchema.parse(source));
    } catch (error) {
      console.error(`convert - zod parse error: ${JSON.stringify(error)}`);
      return err(error as ZodError);
    }
  };

  convert = <SourceType, SchemaType extends z.ZodTypeAny, OutputType>(
    source: SourceType,
    schema: SchemaType
  ): Result<OutputType, ZodError> => {
    if (source == null || source == undefined) {
      const myError = new z.ZodError([
        {
          code: z.ZodIssueCode.custom,
          path: [""],
          message: "Input null or undefined",
        },
      ]);
      return err(myError);
    }
    const baseSchema = Array.isArray(source) ? z.array(schema) : schema;
    const item = source as unknown as OutputType;
    try {
      return ok(baseSchema.parse(item));
    } catch (error) {
      console.error(`convert - zod parse error: ${JSON.stringify(error)}`);
      return err(error as ZodError);
    }
  };
}
